import * as z from "zod";
import { readStepConfig } from "../commitFiles";
import {
  getWorkflowIdForCommit,
  releaseWorkflowSlugIfUnused,
  slugForApp,
} from "../connectorSlug";
import { ensureWritable, modifyStepConfig } from "../copyOnWrite";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";
import { branchSchema, insertUserAction } from "./utils";

export const dissociateStepFromConnectedApp = mutator({
  schema: z
    .object({
      stepDir: z.string(),
      connectedAppId: z.string(),
    })
    .merge(branchSchema),
  resolve: {
    branch: { kind: "branch", from: "branchId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.branch.workflow.spaceId,
    },
  ],
  fn: async ({ tx, ctx, args }) => {
    const {
      stepDir,
      connectedAppId,
      branch,
      forkBranchId,
      forkCommitId,
      forkChatId,
      workingCommitId,
      workingChatId,
    } = args;
    const { commitId } = await ensureWritable(
      tx,
      ctx,
      ctx.tenantId,
      {
        branchId: branch.id,
        forkBranchId,
        forkCommitId,
        forkChatId,
        workingCommitId,
        workingChatId,
      },
      branch
    );

    const workflowId = await getWorkflowIdForCommit(tx, commitId);
    const slug = await slugForApp(tx, workflowId, connectedAppId);

    const config = await readStepConfig({ tx, commitId }, stepDir);
    const connectors = (config.connectors ?? []).filter(
      (a) => a.name !== slug && a.name !== connectedAppId
    );

    await modifyStepConfig(tx, commitId, ctx.tenantId, stepDir, { connectors });

    if (slug !== undefined) {
      await releaseWorkflowSlugIfUnused(tx, workflowId, connectedAppId, slug);
    }

    const [app] = await tx.run(
      zql.connectedApps
        .where("id", connectedAppId)
        .where("tenantId", ctx.tenantId)
    );
    await insertUserAction(
      tx,
      commitId,
      ctx,
      ctx.tenantId,
      "dissociateStepFromConnectedApp",
      {
        stepDir,
        connectedAppId,
        connectedAppName: app?.name ?? connectedAppId,
      }
    );
  },
});
